<app-scroll-view class="scroll-view-main">
  <div class="main-content">
    <div
      #tableContainerEl
      class="table-container"
      style="min-height: calc(3.2rem + (3.2rem * {{ pageSize }}))"
    >
      <app-scroll-view
        class="scroll-view"
        [vertical]="false"
        [horizontal]="true"
        [appBlockModalDrag]="!(isMobileModeObservable | async)"
      >
        <table class="table-results" mat-table [dataSource]="_pagedData">
          <ng-container matColumnDef="actions">
            <th
              mat-header-cell
              *matHeaderCellDef
              class="table-header-cell"
            ></th>
            <td
              mat-cell
              *matCellDef="let element; let i = index"
              class="table-cell actions-column"
            >
              <div #btnLoadMapEl class="btn-item">
                <app-button
                  [buttonType]="isMapLoaded(element) ? 'primary' : 'normal'"
                  styleType="text"
                  sizeType="normal"
                  shapeType="circle"
                  icon="assets/icons/play.svg"
                  (click)="onBtnLoadMapClick(element)"
                ></app-button>

                <app-tooltip
                  [target]="btnLoadMapEl"
                  verticalAlignment="top"
                  horizontalAlignment="center"
                >
                  Carregar mapa
                </app-tooltip>
              </div>
              <div #btnEditEl class="btn-item">
                <app-button
                  buttonType="normal"
                  styleType="text"
                  sizeType="normal"
                  shapeType="circle"
                  icon="assets/icons/pen.svg"
                  (click)="onBtnEditClick(element)"
                ></app-button>

                <app-tooltip
                  [target]="btnEditEl"
                  verticalAlignment="top"
                  horizontalAlignment="center"
                >
                  Editar
                </app-tooltip>
              </div>
              <div #btnDeleteEl class="btn-item">
                <app-button
                  buttonType="danger"
                  styleType="text"
                  sizeType="normal"
                  shapeType="circle"
                  icon="assets/icons/trash.svg"
                  (click)="onBtnDeleteClick(element)"
                  [disabled]="element.favorite"
                ></app-button>

                <app-tooltip
                  [target]="btnDeleteEl"
                  verticalAlignment="top"
                  horizontalAlignment="center"
                >
                  Apagar
                </app-tooltip>
              </div>
              <div #btnShareEl class="btn-item">
                <app-button
                  buttonType="normal"
                  styleType="text"
                  sizeType="normal"
                  shapeType="circle"
                  icon="assets/icons/share-nodes.svg"
                  (click)="onBtnShareClick(element)"
                ></app-button>

                <app-tooltip
                  [target]="btnShareEl"
                  verticalAlignment="top"
                  horizontalAlignment="center"
                >
                  Partilhar
                </app-tooltip>
              </div>
              <div #btnFavoriteEl class="btn-item">
                <app-button
                  [buttonType]="element.favorite ? 'primary' : 'normal'"
                  styleType="text"
                  sizeType="normal"
                  shapeType="circle"
                  icon="assets/icons/star.svg"
                  (click)="onBtnFavoriteClick(element)"
                ></app-button>

                <app-tooltip
                  [target]="btnFavoriteEl"
                  verticalAlignment="top"
                  horizontalAlignment="center"
                >
                  {{ !element.favorite ? "Favorito" : "Remover de favorito" }}
                </app-tooltip>
              </div>
            </td>
          </ng-container>

          <ng-container
            matColumnDef="{{ column.name }}"
            *ngFor="let column of columnsToDisplay"
          >
            <th mat-header-cell *matHeaderCellDef class="table-header-cell">
              {{ column.label ?? column.name }}
            </th>
            <td mat-cell *matCellDef="let element" class="table-cell">
              {{ element[column.name] }}
            </td>
          </ng-container>

          <tr
            mat-header-row
            *matHeaderRowDef="displayedColumns"
            class="table-header"
          ></tr>
          <tr
            mat-row
            *matRowDef="let row; columns: displayedColumns"
            class="table-row"
          ></tr>
        </table>
      </app-scroll-view>

      <app-loading-panel
        [visible]="loadingController.changes | async"
        [container]="tableContainerEl"
      ></app-loading-panel>
    </div>

    <div class="pagination-row">
      <app-pagination
        [totalCount]="resultList?.length ?? 0"
        [pageSize]="pageSize"
        [pageIndex]="pageIndex"
        (pageIndexChange)="onPageIndexChange($event)"
        [appBlockModalDrag]="!(isMobileModeObservable | async)"
      ></app-pagination>
    </div>
  </div>

  <div class="actions-bottom">
    <div
      class="btn-item"
      [appBlockModalDrag]="!(isMobileModeObservable | async)"
      *ngIf="isBtnImportMapVisible"
    >
      <input
        #inputFileEL
        type="file"
        style="display: none"
        accept="text/plain"
        multiple="false"
        (change)="onFileChange()"
      />

      <app-button
        buttonType="primary"
        styleType="contained"
        text="Importar mapa"
        (click)="onBtnImportMapClick()"
      ></app-button>
    </div>

    <div
      class="btn-item"
      [appBlockModalDrag]="!(isMobileModeObservable | async)"
    >
      <app-button
        buttonType="primary"
        styleType="contained"
        text="Criar mapa"
        (click)="mapRegisterModalVisible = true"
        width="13.1rem"
      ></app-button>
    </div>
  </div>
</app-scroll-view>

<app-map-register
  *appDeferRendering="mapRegisterModalVisible"
  [(visible)]="mapRegisterModalVisible"
  [model]="modelToEdit"
  (onSaved)="onSaved()"
  (onClosed)="onRegisterModalClosed()"
></app-map-register>

<app-modal
  *appDeferRendering="mapDeleteModalVisible"
  [(visible)]="mapDeleteModalVisible"
  (onHidden)="modelToEdit = null"
  modalTitle="Apagar Mapa"
  width="30rem"
  height="13rem"
>
  <ng-template modalContent>
    <div class="delete-modal-body-content">
      <div class="message">Deseja apagar o mapa?</div>

      <div class="actions-bottom">
        <app-button
          buttonType="normal"
          styleType="contained"
          text="Cancelar"
          (click)="mapDeleteModalVisible = false"
        ></app-button>
        <app-button
          buttonType="danger"
          styleType="contained"
          text="Apagar"
          (click)="onBtnDoDeleteClick()"
        ></app-button>
      </div>
    </div>
  </ng-template>
</app-modal>
